<template>
    <b-container>
        <h1>Edit Line of Coverage: {{ name }}</h1>
        <form v-on:submit.prevent="saveForm">
            <div class="form-group">
                <label for="name">Name</label>
                <input type="text" class="form-control" id="name" v-model="name">
                <div class="text-danger validation-message" v-if="validation.hasError('name')">
                    The name of the line of coverage is required
                </div>
            </div>
            <div class="form-group">
                <label for="details">Details</label>
                <ckeditor :editor="editor" v-model="details" :config="editorConfig"></ckeditor>
                <div class="text-danger validation-message" v-if="validation.hasError('details')">
                    Details are required
                </div>
            </div>
            <div class="form-group">
                <label for="set_active">Status</label>
                <select class="form-control" id="set_active" v-model="set_active">
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                </select>
            </div>
            <button type="submit" class="btn btn-primary" :disabled="isLoading">
                Save and Update
            </button>
        </form>
    </b-container>
</template>

<script>
import LinesofcoverageDataService from '@/services/LinesofcoverageDataService';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

export default {
    name: "linesofcoverageEdit",
    data() {
        return {
            name: "",
            details: "",
            set_active: 1,
            editor: ClassicEditor,
            editorConfig: {},
            isLoading: false,
        };
    },
    mixins: [SimpleVueValidation.mixin], // Attach the validation plugin
    validators: {
        'name': function (value) {
            return Validator.value(value).required('The name is required');
        },
        'details': function (value) {
            return Validator.value(value).required('Details are required');
        },
    },
    created() {
        LinesofcoverageDataService.getById(this.$route.params.id)
            .then((res) => {
                this.name = res.data.name;
                this.details = res.data.details;
                this.set_active = res.data.set_active;
            })
            .catch(() => {
                alert('Failed to load data. Please try again later.');
                this.$router.push('/linesofcoverage');
            });
    },
    methods: {
        saveForm() {
            this.$validate().then((success) => {
                if (!success) return;
                this.isLoading = true;
                LinesofcoverageDataService.update(this.$route.params.id, {
                    name: this.name,
                    details: this.details,
                    set_active: this.set_active,
                })
                    .then(() => {
                        this.$router.push('/admin/linesofcoverage?updated=true');
                    })
                    .catch(() => {
                        alert('Failed to save data. Please try again.');
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            });
        },
    },
};
</script>

<style>
.validation-message {
    margin-top: -8px;
    margin-bottom: 10px;
}
.doceditor .ck-editor__editable {
    min-height: 73vh !important;
}
</style>
